import {useEffect, useState} from "react";
import {apiUc} from "@/services/api.uc";
import {apiInvite} from "@/services/api.invite";
import cookies from "js-cookie";
import { parse } from "querystring";
interface UserInfo {
    account_name: null | string,
    auth_country_id: number,
    country_code: string,
    country_id: Array<number>,
    email: string,
    fullname: string,
    gmt_created: number,
    lp_type: null | string | number,
    options: {
        conversion_currency: string
    },
    phone: string,
    reg_channel: null | string | number,
    register_ip_country_id: number,
    state: number,
    uid: number,
    user_type: number,
    uuid: string,
    vip_expired: boolean,
    vip_expiry_date: null | string,
    vip_level: number,
}

export const useUserInfo = () => {
    const [userInfo, setUserInfo] = useState<UserInfo>({} as UserInfo);
    const [hasUc, setHasUc] = useState<boolean>(false);

    const param: any = parse(window.location.search.slice(1));
    const invite_code_special = param.invite_code || '';
    const codeFind = "crm_token"+invite_code_special;
    const crm_token = cookies.get(codeFind) || sessionStorage.getItem(codeFind) || "";

    const init =  ()=>{
        if (crm_token) {
             apiInvite
            .getSpecialUid({})
            .then(({ code, data}) => {
                if (code === 200) {
                    // @ts-ignore
                    setUserInfo({uid:data});
                }
            });
        }else{
             apiUc.getUserInfo().then(({ code, data}) => {
                if (code === 200) {
                    setUserInfo(data);
                    setHasUc(true);
                }
            })
        }
    }

    useEffect(() => {
        init();
    }, []);

    return { hasUc, userInfo };
}
